export const BLUEPRINT_PRICE_PER_NIGHT_CURRENCY = 'GBP';

export const blueprintFromPrice = (pricePerNight?: number | null, duration?: number | null) =>
  pricePerNight && duration ? Math.round(pricePerNight * duration) : null;
